import { defineComponent as _defineComponent } from 'vue'
import { normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderSlot as _renderSlot, vShow as _vShow, withDirectives as _withDirectives } from "vue"
import _imports_0 from '../assets/collapsible/dropdown.png'
import _imports_1 from '@/assets/edit.png'
import _imports_2 from '@/assets/delete.png'


const _hoisted_1 = { class: "collapsible-main" }
const _hoisted_2 = { class: "title" }
const _hoisted_3 = { class: "button-section" }
const _hoisted_4 = { class: "collapsible-content" }
const _hoisted_5 = {
  key: 0,
  class: "disabled-overlay"
}

import { ref } from 'vue';
import { CollapsibleSectionEvents, CollapsibleSectionProps } from './componentModel/CollapsibleModel';


export default /*@__PURE__*/_defineComponent({
  __name: 'CollapsibleSection',
  props: {
    title: {},
    isDisabled: { type: Boolean, default: false },
    showDelete: { type: Boolean, default: false },
    showEdit: { type: Boolean, default: false },
    id: {}
  },
  emits: ["deleteClicked", "editClicked"],
  setup(__props: any, { emit: __emit }) {

const props = __props;

const emit = __emit;

// #region Data
const isOpen = ref(true);
// #endregion Data

// #region Methods
const deleteClicked = (e: Event) => {
  // To disabled closing of the section
  e.stopPropagation();
  // Emit the click with the ID
  if (!props.id) {
    console.warn('Delete is enabled, but id is not set for the collapsible section.')
  } else {
    emit('deleteClicked', props.id);
  }
}
const editClicked = (e: Event) => {
  // To disabled closing of the section
  e.stopPropagation();
  // Emit the click with the ID
  if (!props.id) {
    console.warn('Edit is enabled, but id is not set for the collapsible section.')
  } else {
    emit('editClicked', props.id);
  }
}
// #endregion Methods

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", {
      class: _normalizeClass(['title-container', { 'disabled': _ctx.isDisabled }]),
      onClick: _cache[0] || (_cache[0] = ($event: any) => (isOpen.value = !isOpen.value))
    }, [
      _createElementVNode("img", {
        class: _normalizeClass({ 'isOpen': isOpen.value && !_ctx.isDisabled }),
        src: _imports_0,
        alt: ""
      }, null, 2),
      _createElementVNode("div", _hoisted_2, _toDisplayString(_ctx.title), 1),
      _createElementVNode("div", _hoisted_3, [
        (_ctx.showEdit)
          ? (_openBlock(), _createElementBlock("img", {
              key: 0,
              src: _imports_1,
              alt: "Edit",
              onClick: editClicked
            }))
          : _createCommentVNode("", true),
        (_ctx.showDelete)
          ? (_openBlock(), _createElementBlock("img", {
              key: 1,
              src: _imports_2,
              alt: "Delete",
              onClick: deleteClicked
            }))
          : _createCommentVNode("", true)
      ])
    ], 2),
    _withDirectives(_createElementVNode("div", _hoisted_4, [
      _renderSlot(_ctx.$slots, "default")
    ], 512), [
      [_vShow, isOpen.value && !_ctx.isDisabled]
    ]),
    (_ctx.isDisabled)
      ? (_openBlock(), _createElementBlock("div", _hoisted_5))
      : _createCommentVNode("", true)
  ]))
}
}

})